import React from 'react';

const Summary = () => {
  return (
    <section className="summary">
      <p>I currently work in Field Strategy & Planning at Contentful. I love learning about new innovation in technology and I want to support the world's most ambituous technology companies by building GTM and operational systems that are precise, efficient, and built for long-term impact. Below is a summary of my experience but click on the top right icon to download my CV and find out more!</p>
    </section>
  );
};

export default Summary;

